import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Tooltip,
    Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { MainContext } from "../../../main/context/MainContextProvider";
import { DialogHeader } from "../../../auth/components/DialogHeader";
import { PVSystUpload } from "./PVSystUpload";
import { UsinasContext } from "../context/UsinasContextProvider";
import { PVSystToUsina } from "../PVSystMapper";

export function ImportPVSystModal(props: {
    open: boolean;
    setOpen: (open: boolean) => void;

}) {
    const { theme } = useContext(MainContext);
    const { setUsina, usina, pvSyst, setPVSyst } = useContext(UsinasContext);
    const primary = theme.muiTheme.palette.primary.main;
    const { open, setOpen } = props;
    const [isLoading, setIsloading] = useState(false);
    const onClose = () => { setOpen(false); setPVSyst(null) }
    const onConfirm = async () => {
        setIsloading(true);
        const usinaDataFromPVSyst = PVSystToUsina(pvSyst);
        if (!usinaDataFromPVSyst) return;
        if (usina?.usinaIds) {
            setUsina({
                ...usina,
                components: {
                    inverters: {
                        amount: usinaDataFromPVSyst.components?.inverters?.amount,
                        inverterPower:
                            usinaDataFromPVSyst.components?.inverters?.inverterPower,
                    },
                    modules: {
                        amount: usinaDataFromPVSyst.components?.modules?.amount,
                        power: usinaDataFromPVSyst.components?.modules?.power,
                    },
                    string: {
                        amount: usinaDataFromPVSyst.components?.string?.amount,
                    },
                },
                indicators: {
                    ...usinaDataFromPVSyst.indicators,
                    megaWattValue: usina?.indicators?.megaWattValue,
                    variance: usina?.indicators?.variance,
                    efficiency: usina?.indicators?.efficiency,
                },
                location: usinaDataFromPVSyst.location,
            })
        }
        onClose()
        setIsloading(false);
    };
    return (
        <Dialog
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <DialogHeader id="customized-dialog-title" onClose={onClose}>
                Importação do PVSyst
            </DialogHeader>
            <DialogContent
                sx={{
                    width: "450px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                }}
                dividers
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "20px",
                    }}
                >
                    <PVSystUpload />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button color="secondary" onClick={onClose}>
                    Cancelar
                </Button>
                <Tooltip title={!pvSyst && <Typography sx={{ fontSize: "13px" }}>É necessário fazer o upload do arquivo para conseguir fazer a importação!</Typography>} placement="top">
                    <Box>
                        <Button
                            disabled={isLoading || !pvSyst}
                            sx={{
                                backGroundColor: primary,
                                borderColor: primary,
                                height: "34px",
                                width: "95px",
                                "& .MuiTypography-root": {
                                    color: primary,
                                },
                                "&:hover": {
                                    borderColor: primary,
                                    backgroundColor: primary,
                                    color: primary,
                                    "& .MuiTypography-root": {
                                        color: "#FFFFFF",
                                    },
                                },
                            }}
                            variant="contained"
                            color={"primary"}
                            onClick={onConfirm}
                        >
                            Importar
                        </Button></Box></Tooltip>
            </DialogActions>
        </Dialog>
    );
}
